import { render, staticRenderFns } from "./AccountDomainLeaveStep1.vue?vue&type=template&id=51c29854&"
import script from "./AccountDomainLeaveStep1.vue?vue&type=script&lang=ts&"
export * from "./AccountDomainLeaveStep1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports